// Memuat konten dari R2 lewat /api/content/*. Jika gagal (offline, R2 kosong, atau
// belum login), aplikasi memakai config dan kartu rumus bawaan yang ikut dibundel.
// Bank soal tidak dibundel, supaya kunci jawabannya hanya tersedia setelah login.
import configBawaan from '../../content/config.json';
import rumusMatematika from '../../content/rumus/matematika.json';
import { normalisasiConfig, normalisasiRumus, normalisasiBankSoal, pathAman } from './validasi.js';

export const API_KONTEN = '/api/content/';
const RUMUS_BAWAAN = { matematika: rumusMatematika };
const { config: CONFIG_BAWAAN } = normalisasiConfig(configBawaan, configBawaan);

async function ambilJSON(path, timeout = 6000) {
  if (!pathAman(path)) throw new Error('Path konten tidak valid: ' + path);
  const ctl = new AbortController();
  const t = setTimeout(() => ctl.abort(), timeout);
  try {
    const r = await fetch(API_KONTEN + path, { credentials: 'same-origin', signal: ctl.signal });
    if (!r.ok) throw new Error(`HTTP ${r.status} untuk ${path}`);
    return await r.json();
  } finally {
    clearTimeout(t);
  }
}

/**
 * @returns {Promise<{config: object, rumus: Record<string, object[]>, bank: Record<string, object[]>, sumber: Record<string, string>, galat: string[]}>}
 */
export async function muatKonten() {
  const hasil = { config: CONFIG_BAWAAN, rumus: {}, bank: {}, sumber: {}, galat: [] };
  if (typeof __DEMO__ !== 'undefined' && __DEMO__) {
    // Mode demo: semua konten ikut dibundel (tanpa R2). Cabang ini dibuang saat build produksi.
    const bank = (await import('../../content/bank-soal/matematika.json')).default;
    const bankBI = (await import('../../content/bank-soal/bahasa-indonesia.json')).default;
    for (const [id, raw] of Object.entries(RUMUS_BAWAAN)) hasil.rumus[id] = normalisasiRumus(raw).kartu;
    hasil.bank.matematika = normalisasiBankSoal(bank).soal;
    // Gambar konten ikut dibundel sebagai data URL.
    const gambar = import.meta.glob('../../content/gambar/*.{png,jpg,jpeg,webp}', { eager: true, query: '?inline', import: 'default' });
    const prefixGambar = p => gambar['../../content/' + p] || '';
    hasil.bank['bahasa-indonesia'] = normalisasiBankSoal(bankBI, { mapel: 'bahasa-indonesia', prefixGambar }).soal;
    hasil.sumber = { config: 'bawaan', rumus: 'bawaan', bank: 'bawaan' };
    return hasil;
  }
  try {
    const n = normalisasiConfig(await ambilJSON('config.json'), configBawaan);
    hasil.config = n.config;
    hasil.galat.push(...n.galat);
    hasil.sumber.config = 'server';
  } catch (e) {
    hasil.sumber.config = 'bawaan';
  }

  await Promise.all(hasil.config.mapel.filter(m => m.aktif).map(async m => {
    if (m.rumus) {
      let raw = null;
      try { raw = await ambilJSON(m.rumus); hasil.sumber['rumus:' + m.id] = 'server'; }
      catch (e) { raw = RUMUS_BAWAAN[m.id] || null; hasil.sumber['rumus:' + m.id] = raw ? 'bawaan' : 'tidak ada'; }
      const n = raw ? normalisasiRumus(raw) : { kartu: [], galat: [] };
      hasil.rumus[m.id] = n.kartu;
      hasil.galat.push(...n.galat.map(g => `${m.rumus}: ${g}`));
    }
    hasil.bank[m.id] = [];
    if (m.bankSoal) {
      try {
        const n = normalisasiBankSoal(await ambilJSON(m.bankSoal.file), { prefixGambar: API_KONTEN, mapel: m.id });
        hasil.bank[m.id] = n.soal;
        hasil.galat.push(...n.galat.map(g => `${m.bankSoal.file}: ${g}`));
        hasil.sumber['bank:' + m.id] = 'server';
      } catch (e) {
        hasil.sumber['bank:' + m.id] = 'tidak ada';
      }
    }
  }));
  if (hasil.galat.length) console.warn('Konten punya masalah dan sebagian dilewati:\n' + hasil.galat.join('\n'));
  return hasil;
}

export { CONFIG_BAWAAN };
